<template>
  <div class="mb-2 fw-bold">Delete this user?</div>
  <button type="button" class="btn btn-danger mx-2" @click="deleteUser">
    Delete
  </button>
  <button
    type="button"
    class="btn btn-primary mx-2"
    @click="deactivateComponentFunc()"
  >
    Cancel
  </button>
</template>

<script lang="ts">
import { deleteUser } from '@/common/api';
import { defineComponent } from 'vue';
import { handleError } from '@/common/errors';

export default defineComponent({
  name: 'AdminTableDeleteUserButton',

  props: {
    recordId: {
      type: Number,
      required: true,
    },
    deactivateComponentFunc: {
      type: Function,
      required: true,
    },
    reloadAdminTable: {
      type: Function,
      required: true,
    },
    recreateTableFunc: {
      type: Function,
      required: true,
    },
    setError: {
      type: Function,
      required: true,
    },
  },

  methods: {
    async deleteUser() {
      try {
        await deleteUser(this.recordId);
        this.deactivateComponentFunc();
        this.recreateTableFunc();
      } catch (error: unknown) {
        this.deactivateComponentFunc();
        handleError(error, 'Failed to delete user');
      }
    },
  },
});
</script>
